import Vue from 'vue'
import VueI18n from 'vue-i18n'
// import locale maps
import en from './locale/en.json'
import fr from './locale/fr.json'
import de from './locale/de.json'
import pt from './locale/pt.json'
import ru from './locale/ru.json'
import zh from './locale/zh.json'

Vue.use(VueI18n)

const messages = {
  en,
  fr,
  de,
  pt,
  ru,
  zh
}

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: 'en',
  messages
})

const translate = (value) => {
  if (!value) {
    return ''
  }
  return i18n.t(value)
}

Vue.filter('translate', (value) => {
  return translate(value)
})

export { i18n, translate }
